import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { LoggedUser } from '../../redux/Slices/AuthSlice'

const UseProtectedLinks = () => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true)
    const [isLogin, setIsLogin] = useState()
    const [isUser, setIsUser] = useState()
    const [isAdmin, setIsAdmin] = useState()
    const { IsLogin } = useSelector(state => state.AuthReducer)
    const handleGetLoggedUser = async () => {
        setLoading(true)
        await dispatch(LoggedUser())
        setLoading(false)
    }
    useEffect(() => {
        handleGetLoggedUser()
    }, [])


    useEffect(() => {
        if (loading === false) {
            if (IsLogin && IsLogin.status === 200) {
                if (IsLogin && IsLogin.data.data.role === "user") {
                    setIsLogin(true)
                    setIsUser(true)
                    setIsAdmin(false)
                }
                else if (IsLogin && IsLogin.data.data.role === "admin") {
                    setIsLogin(true)
                    setIsUser(false)
                    setIsAdmin(true)
                }
            } else if (IsLogin && IsLogin.response.status === 500) {
                setIsLogin(false)
                setIsUser(false)
                setIsAdmin(false)
            }
        }
    }, [loading])

    return [isLogin, isUser, isAdmin]
}

export default UseProtectedLinks
